import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Class } from '../../../data/class';
import { Student } from '../../../data/student';
import { BaseComponent } from '../../../base/base.component';
import { json2csv } from 'json-2-csv';
import { FileUtilities } from '../../../utilities/file-utilities';
import { DatepickerViewModel } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model';

@Component({
  selector: 'app-admin-accounts-report',
  templateUrl: './admin-accounts-report.component.html',
  styleUrls: ['./admin-accounts-report.component.scss']
})
export class AdminAccountsReportComponent extends BaseComponent implements OnInit {
  
  organizationID: number;
  running = false;

  getResult(): void {
    this.running = true;
    this.dataService.getAdminAccountsReport(this.organizationID).subscribe(json => {
      this.running = false;
      json2csv(json, (err, csv) => {
        FileUtilities.saveFile(csv, 'AdminAccountsReport_' + this.organizationID + '.csv', 'text/csv');
       });
    }); 
  }
}
